import { BranchAction, BranchState } from 'store/data/branch';
import { domainUtility } from 'utility';

const initialState: BranchState = { allIds: [], byId: {} };

const branchReducer = (
  state: BranchState = initialState,
  action: BranchAction,
): BranchState => {
  switch (action.type) {
    case 'data/branch/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/branch/SET':
      return domainUtility.set(state, action.payload);
    case 'data/branch/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/branch/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/branch/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default branchReducer;
